// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FHVZ","input":"styles_input__2MK8N"};